// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"NavLink_NavLink__2I0g9","active":"NavLink_active__28MaI","body":"NavLink_body__3wF5r","text":"NavLink_text__JqObm","textActive":"NavLink_textActive__25wip"};